import { PayoutAccountTypeEnum, PayServiceTypeEnum } from 'app/models';

export class PayServiceTypeModel {
    public static PayServiceTypeList: Array<any> = [
        { name: 'All', value: 0 },
        { name: 'Gcash', value: PayServiceTypeEnum.GCash },
        { name: 'Maya', value: PayServiceTypeEnum.PayMaya },
        { name: 'Credit Card', value: PayServiceTypeEnum.CreditCard },
        { name: 'Xpress Wallet', value: PayServiceTypeEnum.XpressWallet },
        { name: 'Union Bank', value: PayServiceTypeEnum.BaUbp },
        { name: 'Bank of the Philippine Islands', value: PayServiceTypeEnum.BaBpi },
        { name: 'China Bank', value: PayServiceTypeEnum.BaCb },
        { name: 'Philippine National Bank', value: PayServiceTypeEnum.BaPnb },
        { name: 'East West Bank', value: PayServiceTypeEnum.BaEwb },
        { name: 'Cash', value: PayServiceTypeEnum.Cash },
        { name: 'For Company', value: PayServiceTypeEnum.ForCompany }
    ];

    public static CommonPaymentMethods: Array<any> = [
        { name: 'Gcash', type: PayoutAccountTypeEnum.EWallet, value: PayServiceTypeEnum.GCash },
        { name: 'Maya', type: PayoutAccountTypeEnum.EWallet, value: PayServiceTypeEnum.PayMaya },
        { name: 'Union Bank', type: PayoutAccountTypeEnum.Bank, value: PayServiceTypeEnum.BaUbp },
        { name: 'Bank of the Philippine Islands', type: PayoutAccountTypeEnum.Bank, value: PayServiceTypeEnum.BaBpi }
    ];
}
